// extracted by mini-css-extract-plugin
module.exports = {"ItemLink":"ItemLink_ItemLink__2TzVe"};